/* The A/B template shows the theme product section and the redesign section
   together. The bundle app patches window.fetch globally, thus it rewrote the
   theme section add with its own offer 0, and every add became quantity 1.
   Send that add through an unpatched fetch. Clicks in app UI are ignored. */
(function () {
  var LOG = '[sh-legacy-atc]';

  var SECTION = '[id^="shopify-section-"]';
  var SH_SECTION = '[id^="shopify-section-sh-"]';

  // an app button can point at the theme form, thus match on position
  var SH_UI = [SH_SECTION, '.sh-hero', '.sh-buy__app', '.sh-bundle', 'sh-bundle', '[data-sh-combo]'].join(',');

  /* The subscription toggle is 'onetime' or 'subsave'; a select holds the plan
     id. Never treat an unknown value as a single purchase: that sells a
     subscription at the full price, and the page shows no error. */
  var ONE_TIME = /^(onetime|one-time|one_time|single|)$/i;
  var PLAN_FIELD = '[name^="selling_plan"]';
  var PLAN_ID = /^\d+$/;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Borrow a clean fetch from an iframe. Only the top window is patched. Keep
     the iframe: remove it and its realm closes, and the function stops. */
  var rawFetch;

  function cartFetch(url, opts) {
    if (rawFetch === undefined) {
      rawFetch = null;
      try {
        var frame = document.createElement('iframe');
        frame.setAttribute('aria-hidden', 'true');
        frame.tabIndex = -1;
        frame.style.cssText =
          'position:absolute;top:0;left:0;width:0;height:0;border:0;visibility:hidden';
        document.body.appendChild(frame);
        var borrowed = frame.contentWindow && frame.contentWindow.fetch;
        if (typeof borrowed === 'function') rawFetch = borrowed.bind(frame.contentWindow);
      } catch (e) {
        // cross-origin lockdown, or no body yet. Use the patched fetch.
      }
    }
    return (rawFetch || window.fetch)(url, opts);
  }

  // the section holds several cart/add forms, thus search the whole section
  function scopeOf(form) {
    var section = form.closest(SECTION);
    return section && !section.matches(SH_SECTION) ? section : form;
  }

  function ours(el) {
    return !el.closest(SH_UI);
  }

  // fields can sit outside the form, with a form attribute. Collect those too.
  function fieldsFor(form, query) {
    var list = [].slice.call(scopeOf(form).querySelectorAll(query));

    if (form.id) {
      [].slice.call(document.querySelectorAll(query + '[form]')).forEach(function (el) {
        if (el.getAttribute('form') === form.id && list.indexOf(el) === -1) list.push(el);
      });
    }

    return list.filter(ours);
  }

  function quantityOf(form) {
    var inputs = fieldsFor(form, 'input[name="quantity"]');
    var value = parseInt(inputs.length && inputs[0].value, 10);
    return value > 0 ? value : 1;
  }

  function sellingPlanOf(form) {
    var fields = fieldsFor(form, PLAN_FIELD);
    var toggle = null;
    var select = null;

    fields.forEach(function (el) {
      var type = (el.type || '').toLowerCase();
      if (type === 'radio' || type === 'checkbox') {
        if (el.checked && !toggle) toggle = el;
      } else if (!select && el.name === 'selling_plan') {
        select = el;
      }
    });

    if (!toggle) return ''; // no subscription option on this product

    var value = (toggle.value || '').trim();
    if (ONE_TIME.test(value)) return '';
    if (PLAN_ID.test(value)) return value;

    // 'subsave' or similar. The select holds the plan id.
    var plan = select && (select.value || '').trim();
    if (PLAN_ID.test(plan)) return plan;

    // no select. Read the plan id out of the field name.
    var id = (toggle.name.match(/(\d{6,})/) || [])[1];
    if (id) return id;

    console.error(LOG, 'unknown selling plan value:', value);
    return '';
  }

  function payloadOf(form) {
    var data = new FormData(form);

    // send only selling_plan. Collect the keys first: do not delete while reading.
    var stale = [];
    data.forEach(function (value, key) {
      if (key.indexOf('selling_plan') === 0) stale.push(key);
    });
    stale.forEach(function (key) {
      data.delete(key);
    });

    data.set('quantity', String(quantityOf(form)));

    var plan = sellingPlanOf(form);
    if (plan) data.set('selling_plan', plan);

    return data;
  }

  function call(name) {
    var fn = window[name];
    if (typeof fn !== 'function') return null;
    try {
      return Promise.resolve(fn());
    } catch (e) {
      console.error(LOG, name, e);
      return Promise.resolve();
    }
  }

  // UpCart never saw the add, thus refresh it before you open it.
  // This fetch is borrowed from an iframe, so the header badge wrapper
  // never sees it. Ask the badge to read /cart.js itself.
  function openDrawer() {
    if (typeof window.seppSyncHeaderCart === 'function') window.seppSyncHeaderCart();

    var refresh = call('upcartRefreshCart') || call('upcartUpdateCart');
    if (refresh || typeof window.upcartOpenCart === 'function') {
      (refresh || Promise.resolve()).then(function () {
        call('upcartOpenCart');
      });
      return;
    }

    var slidecart = call('SLIDECART_UPDATE');
    if (slidecart) {
      slidecart.then(function () {
        call('SLIDECART_OPEN');
      });
      return;
    }

    if (document.querySelector('cart-drawer')) {
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      return;
    }

    window.location = root() + 'cart';
  }

  // the theme renders errors as .errors in the form error container
  function showError(form, message) {
    var box = scopeOf(form).querySelector('[data-cart-errors-container]');
    if (!box) {
      console.error(LOG, message);
      return;
    }

    box.textContent = '';
    var line = document.createElement('div');
    line.className = 'errors';
    line.textContent = message;
    box.appendChild(line);
    box.classList.add('visible');
  }

  function release(button) {
    button.classList.remove('loading');
    button.disabled = false;
  }

  function submit(form, button) {
    if (button.disabled) return;
    button.classList.add('loading');
    button.disabled = true;

    cartFetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: payloadOf(form),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        release(button);
        if (data && data.status) {
          showError(form, data.description || data.message || 'add failed');
          return;
        }
        openDrawer();
      })
      .catch(function (err) {
        release(button);
        console.error(LOG, err);
        showError(form, String((err && err.message) || err));
      });
  }

  // capture phase. Stop the theme and app handlers, or the item is added twice.
  document.addEventListener(
    'click',
    function (e) {
      var button = e.target.closest('.product-form__submit, button[name="add"]');
      if (!button) return;

      // the dynamic checkout button goes to its own flow
      if (button.closest('.shopify-payment-button')) return;

      // the app owns its buttons, also when they point at the theme form
      if (!ours(button)) return;

      var form = button.form || button.closest('form');
      if (!form || (form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      if (!ours(form)) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      submit(form, button);
    },
    true
  );
})();
